module.exports = __webpack_public_path__ + "static/espacio_conmpartido-min-d2909c32974bd0a224c6b56377a1660b.jpg";